import { Time } from "@angular/common";

export class TransactionSearchModel {
    public MessageId!: string;
    public RelatesToMessageId!: string;
    public PharmacyVendor!: any;
    public PharmacyId!: string;
    public PharmacyName!: any;
    public PharmacyNcpdpid!: String;
    public ResponseStatus!: String;
    public IsPet!: any;
    public PatientLastName!: String;
    public PatientDOB!: any;
    public StartDate!: String;
    public EndDate!: String;
    public BeginDateTime!:String
    public EndDateTime!:String
    public PageNumber!:number
    public PageSize!:number
    public MessageType!:String
}